import script from "./ProductMetaContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductMetaContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ProductMetaContainer.vue?vue&type=style&index=0&id=7fb35672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb35672"]])

export default __exports__